import React from 'react'
import { ArrowRightIcon } from 'lucide-react'
import { ClipLoader } from 'react-spinners'

const StickyBar = ({ handleUnlock, isModalLoading }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-white/10 bg-[#102D47] px-3 py-3 shadow-[0_-4px_18px_rgba(0,0,0,0.3)]">
      <div className="flex flex-col gap-2 w-full max-w-md mx-auto">
        <button 
            onClick={handleUnlock}
            className="flex flex-col gap-1 items-center justify-center w-full bg-[#7fc241] hover:bg-[#7fc241]/90 text-[#121212] font-bold py-2 rounded-lg transition-colors leading-none"
        >
            {isModalLoading ? <ClipLoader size={20} color="#121212" /> : <> 
            <span className="text-[#121212] font-medium text-[16px] whitespace-nowrap flex items-center gap-1">Unlock Course Now <ArrowRightIcon className="w-4 h-4" strokeWidth={2.5} /></span>
            
            <span className="text-[#121212]/70 text-[12px] font-medium whitespace-nowrap">Just For ₹399 <span className="text-[#E06064] line-through text-[12px] font-medium">₹999</span></span></>}
            
        </button>
        <p className="text-center text-white text-[12px] sm:text-xs italic opacity-90">
            (Limited-time pricing for active learners)
        </p>
      </div>
    </div>
  )
}

export default StickyBar
